import { useParams } from "react-router-dom";

// reusable components
import ProductPageForm from "@/views/admin/products/components/ProductPageForm";

export default function ProductDetails() {
    const { id } = useParams();
    const isEditMode = id !== "new";

    return (
        <div className="flex flex-col">
            <ProductPageForm productId={isEditMode ? id : null} />
        </div>
    );
};